var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from "@emotion/css";
var HorizontalLine = function () {
    return (_jsx("div", { className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: 85%;\n        border-top: 1px solid #ccc;\n        margin: 6px 0px;\n      "], ["\n        width: 85%;\n        border-top: 1px solid #ccc;\n        margin: 6px 0px;\n      "]))) }));
};
export default HorizontalLine;
var templateObject_1;
